// architect.view_architect
import React from "react";
import { get } from "lodash";
import { BaseList, BaseDetail } from "App/Component/Bases";
import fields from "./fields";
import descriptor from "./descriptor";
import options from "./options";
import { Button, Icon, Tabs } from "antd";
import ArchitectAliasList from "./Aliases";
import DialogMergeArchitects from "./DialogMerge";

const title = "Architect";
const urlData = "architects";
const bulkName = "name";

class List extends BaseList {
  constructor(props) {
    super(props)

    this.title = title;
    this.urlData = urlData;
    this.bulkName = bulkName;
    this.propsList = {
      descriptor,
      exportImport: options.exportImportOptions,
      getAnotherActions: this.getAnotherActions,
    }

    this.state = {
      ...this.state,
      visibleDialogMerge: false,
    }
  }

  getAnotherActions = (_ref) => {
    return (
      <span>
        <DialogMergeArchitects
          visible={this.state.visibleDialogMerge}
          onClose={() => this.setState({ visibleDialogMerge: false }, () => get(_ref, 'reloadPage') && _ref.reloadPage())}
        />

        <Button icon="pull-request" onClick={() => this.setState({ visibleDialogMerge: true })}>
          Merge Architects
        </Button>
      </span>
    )
  }
}

class Detail extends BaseDetail {
  constructor(props) {
    super(props)

    this.title = title
    this.urlData = urlData
    this.bulkName = bulkName
    this.fields = fields
    this.propsDetail = {
      urlKeyHistory: 'api:admin:architect:architect:detail-revision',
      keyLabel: 'name',
      getAnotherTabPanes: this.getAnotherTabPanes,
      renderTitle: this.renderTitle,
    }
  }

  renderTitle = (record) => {
    console.log('Rendered', this)
    return (
      <div>
        {title} {get(record, 'name') && `"${record.name}"`}
      </div>
    )
  }

  getAnotherTabPanes = () => {
    console.log('getAnotherTabPanes', this)
    return !this.props.match.params.historyId && (
      <Tabs.TabPane
        key='alias'
        tab={
          <span>
            {/* <Icon type='info-circle' /> */}
            Alias
          </span>
        }
      >
        <ArchitectAliasList architectId={this.props.match.params.id} /> 
      </Tabs.TabPane>
    )
  }
}

export default { List, Detail };
